export enum EFeatureFlags {
  ERP_COMMENTS = 'erp_comments', // https://xometry.atlassian.net/browse/XEMSG-821
  ARAS_ORDER = 'erp_aras_order',
  YURTICI_ORDER = 'erp_yurtici_order',
  DB_SCHENKER_ORDER = 'erp_db_schenker_order',
  ERP_TEMPLATES_MODAL_EMAIL_CUSTOMER = 'erp_templates_modal_email_customer', // https://xometry.atlassian.net/browse/XEMSG-1081

  /**
   * https://xometry.atlassian.net/browse/XEMSG-1352
   */
  ERP_TEMPLATES_MODAL_EMAIL_ENQUIRY = 'erp_templates_modal_email_enquiry',
  ERP_TEMPLATES_MODAL_EMAIL_OC = 'erp_templates_modal_email_oc',
  ERP_TEMPLATES_MODAL_EMAIL_OI = 'erp_templates_modal_email_oi',
  ERP_TEMPLATES_MODAL_EMAIL_II = 'erp_templates_modal_email_ii',
  ERP_TEMPLATES_MODAL_EMAIL_QUALITY_CONTROL = 'erp_templates_modal_email_quality_control',
  ERP_TEMPLATES_MODAL_EMAIL_CLAIM = 'erp_templates_modal_email_claim',
  ERP_TEMPLATES_MODAL_EMAIL_PAYMENT = 'erp_templates_modal_email_payment',

  /**
   * Custom messenger templates.
   *
   * https://xometry.atlassian.net/browse/XEMSG-1256
   * https://xometry.atlassian.net/browse/XEMSG-1017
   */
  ERP_MESSENGER_TEMPLATES = 'erp_messenger_templates',

  XMAS_ENABLED = 'erp_xmas_enabled',
  HALLOWEEN_ENABLED = 'erp_halloween_enabled',

  /**
   * https://xometry.atlassian.net/browse/XETW-1579
   */
  CUSTOMER_OBJECTS_ENABLED = 'erp_customer_objects_enabled',

  MOLDING_TOOLS_ENABLED = 'erp_molding_tools_enabled',
  MANUAL_INTERCOMPANY_CUSTOMERS_MIGRATION = 'erp_manual_intercompany_customers_migration',
  EMULATE_PERSON_ACCOUNT = 'erp_emulate_person_account',

  CERTIFICATES_AS_ADDITIONAL_SERVICES = 'erp_certificates_as_additional_services',

  /**
   * https://xometry.atlassian.net/browse/EUO-390
   */
  L2G_BILLING_PREFERENCE_ENABLED = 'erp_billing_preference_enabled',
}
